module.exports = __webpack_public_path__ + "static/fonts/D-DIN-PRO-600-SemiBold.13694804.otf";